import { render, staticRenderFns } from "./HoldBillDialog.vue?vue&type=template&id=11d7e12a&"
import script from "./HoldBillDialog.vue?vue&type=script&lang=js&"
export * from "./HoldBillDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSeparator,QInput,QIcon,QBadge,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn,QCardActions,QField,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSeparator,QInput,QIcon,QBadge,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn,QCardActions,QField})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
